module.exports = __webpack_public_path__ + "static/media/subscribe-device@3x-nick.29bf3ea5.png";